var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordFancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_image",
    "data-name": "password image",
    transform: "translate(-134.473 -238.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(24.644 166.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.002 -14.75)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.002 0.25)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "privacy_2_",
    "data-name": "privacy (2)",
    transform: "translate(21.998 17.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9371",
    "data-name": "Path 9371",
    d: "M172.969,298.678a1.055,1.055,0,0,1-1.055-1.055v-4.369a1.055,1.055,0,0,1,2.109,0v4.369A1.055,1.055,0,0,1,172.969,298.678Zm0,0",
    transform: "translate(-159.826 -271.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9372",
    "data-name": "Path 9372",
    d: "M1.055,11.568H6.046V6.431C6.046,2.885,9.23,0,13.142,0s7.1,2.885,7.1,6.431v5.138H25.23a1.055,1.055,0,0,1,1.055,1.055V26.111A9.9,9.9,0,0,1,16.4,36H9.888A9.9,9.9,0,0,1,0,26.111V12.623a1.055,1.055,0,0,1,1.055-1.055ZM18.129,6.431c0-2.383-2.237-4.321-4.986-4.321S8.156,4.048,8.156,6.431v5.138h9.973ZM2.109,26.111A7.788,7.788,0,0,0,9.889,33.89H16.4a7.788,7.788,0,0,0,7.779-7.779V13.678H2.109Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordFancy);
export default __webpack_public_path__ + "static/media/password-fancy.11f18ba7cc784c7c1f87b3c3e84e0c1a.svg";
export { ForwardRef as ReactComponent };